import React from 'react';
import './CustomWaves.css';

const CustomWaves = () => {
  return (
    <div className="custom-waves-header z-0 -top-3 bg-[#f2eee7]">
      
      <div>
        <svg
          className="custom-waves-svg h-24 overflow-hidden"
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
          viewBox="0 24 150 28"
          preserveAspectRatio="none"
          shapeRendering="auto"
        >
          <defs>
            <path
              id="gentle-wave"
              d="M-160 44c30 0 58-18 88-18s 58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z"
            />
          </defs>
          <g className="custom-waves-parallax">
            <use xlinkHref="#gentle-wave" x="48" y="0" fill="rgba(242, 238, 231,0.7)" />
            <use xlinkHref="#gentle-wave" x="48" y="3" fill="rgba(242, 238, 231,0.5)" />
            <use xlinkHref="#gentle-wave" x="48" y="5" fill="rgba(242, 238, 231,0.3)" />
            <use xlinkHref="#gentle-wave" x="48" y="7" fill="#f2eee7" />
          </g>
        </svg>
      </div>

    
    </div>
  );
};

export default CustomWaves;
